import { useContext, useState, useEffect, useCallback, useRef } from "react";
import { useFocusEffect } from "@react-navigation/native";
import {
  StyleSheet,
  View,
  Text,
  AppState,
} from "react-native";
import { ScrollView, RefreshControl } from "react-native-gesture-handler";
import SafeAreaView from "../components/SafeAreaView";
import SensorMainItem from "../components/SensorMainItem";

import { AuthContext } from "../context/AuthContext";
import { NotifyContext } from "../components/Notification";
import * as Config from "../config";
import axios from "axios";
import qs from "qs";
import { SensorMainSubitem } from "../components/SensorMainSubitem";
import PageHeader from "../components/PageHeader";
import { EventRegister } from "react-native-event-listeners";
import { getSchemeStyle } from "../context/helper";
import ActivityScreen from "./activityscreen";

const MainScreen = ({ navigation }) => {
  const schemeStyles = getSchemeStyle();

  const { userToken, useFirm } = useContext(AuthContext);
  const { addFGListener } = useContext(NotifyContext);

  const [dataLoaded, setDataLoaded] = useState(false);
  const [sensorData, setSensorData] = useState([]);
  const [stickeIdx, setStickyIdx] = useState([]);

  const [refreshing, setRefreshing] = useState(false);

  const lastReload = useRef(null);
  const firstLoaded = useRef(false);

  const changeSensorData = (data) => {
    let newdata = [];
    let idx = [];
    let id = -1;
    data.forEach((item) => {
      id++;
      idx = [...idx, id];
      newdata.push({
        standortID: item.standortID,
        standortName: item.standortName,
        sensor: null,
      });
      item.sensoren.forEach((sens) => {
        newdata.push({
          standortID: item.standortID,
          standortName: item.standortName,
          sensor: sens,
        });
        id++;
      });
      id++;
      newdata.push({
        standortID: item.standortID,
        standortName: null,
        sensor: null,
      });
    });
    setSensorData(newdata);
    setStickyIdx(idx);
  };

  const loadData = async (dorefresh) => {
    dorefresh ? setRefreshing(true) : setDataLoaded(false);

    const url = `${Config.BASE_URL}/getdata`;
    let data = {
      action: "sensorview",
      firmid: useFirm.current,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        let _sensordata = res.data;
        //console.log(_sensordata);
        //console.log(_sensordata.data[0].sensoren[0]);
        if (_sensordata && _sensordata.result == "OK") {
          changeSensorData(_sensordata.data);
        }
      })
      .catch((e) => {
        console.log(`SensorView error ${e}`);
      });
    lastReload.current = new Date();
    firstLoaded.current = true;
    dorefresh ? setRefreshing(false) : setDataLoaded(true);
  };

  const onRefresh = useCallback(() => {
    loadData(true);
  }, []);

  const checkReload = () => {
    if (lastReload.current) {
      let now = new Date();
      return (
        Math.floor((now.getTime() - lastReload.current.getTime()) / 1000) >= 900
      );
    }
    return true;
  };

  const intervalAct = () => {
    if (!refreshing && dataLoaded) {
      if (checkReload()) loadData(true);
    }
  };
  const screenName = (name) => {
    const state = navigation.getState();
    return state.routes[state.index].name === name;
  };
  useFocusEffect(() => {
    if (firstLoaded.current && checkReload()) {
      loadData(true);
    }
    const interval = setInterval(() => {
      intervalAct();
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  });

  useEffect(() => {
    if (!firstLoaded.current) {
      loadData(false);
    }

    addFGListener((isFG, notification) => {
      lastReload.current = null;
      if (isFG && screenName("Main")) intervalAct();
    });

    const subscription = AppState.addEventListener("change", (nextAppState) => {
      if (nextAppState === "active") {
        //console.log("App State: " + "App has come to the foreground!");
        if (screenName("Main")) intervalAct();
      }
    });
    return () => {
      subscription.remove();
    };
  }, []);

  useEffect(() => {
    const emitBranchChange = EventRegister.addEventListener(
      Config.Events.BRANCH_CHANGE,
      (msg) => {
        //console.log(`Branch Changed SensorMain: ${msg.branchid}`);
        let changedData = [...sensorData];
        changedData.forEach((item) => {
          if (item.standortID === msg.branchid && item.standortName) {
            item.standortName = msg.branchname;
          }
        });

        //console.log(changedData.filter((item)=> item.standortID===msg.branchid));
        setSensorData(changedData);
      }
    );
    const emitSensorActivate = EventRegister.addEventListener(
      Config.Events.SENSOR_ACTIVATE,
      (msg) => {
        if (msg.result) {
          lastReload.current = null;
          //loadData(true);
        }
      }
    );
    const emitSensorChange = EventRegister.addEventListener(
      Config.Events.SENSOR_CHANGE,
      (msg) => {
        if (msg.activeChange) {
          lastReload.current = null;
          //loadData(true);
        } else {
          let changedData = [...sensorData];
          changedData.forEach((item) => {
            if (item.sensor && item.sensor.sensorID === msg.sensorID) {
              item.sensor.sensorName = msg.sensorName;
            }
          });

          //console.log(changedData.filter((item)=> item.standortID===msg.branchid));
          setSensorData(changedData);
        }
      }
    );
    return () => {
      EventRegister.removeEventListener(emitBranchChange);
      EventRegister.removeEventListener(emitSensorActivate);
      EventRegister.removeEventListener(emitSensorChange);
    };
  }, [sensorData]);

  if (!dataLoaded) {
    return (
      <ActivityScreen />
    );
  }

  return (
    <SafeAreaView style={[styles.mainContainer, schemeStyles.Background]}>
      <PageHeader navigation={navigation} />
      <ScrollView
        style={styles.scrollContainer}
        stickyHeaderIndices={stickeIdx}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
      >
        {sensorData.length > 0 ? (
          sensorData.map((item) =>
            item.sensor === null ? (
              item.standortName !== null ? (
                <SensorMainItem
                  key={"B_" + item.standortID}
                  item={item}
                  onPress={() => {
                    navigation.navigate("Branch", {
                      branchid: item.standortID,
                    });
                  }}
                />
              ) : (
                <SensorMainSubitem key={"E_" + item.standortID} />
              )
            ) : (
              <SensorMainSubitem
                key={item.sensor.sensorID}
                item={item.sensor}
                onPress={() => {
                  navigation.navigate("Sensor", {
                    branchid: item.standortID,
                    sensorid: item.sensor.sensorID,
                  });
                }}
              />
            )
          )
        ) : (
          <View style={styles.noData}>
            <Text>Keine Daten</Text>
          </View>
        )}
      </ScrollView>
    </SafeAreaView>
  );
};

export default MainScreen;

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    paddingVertical: 20,
  },
  scrollContainer: {
    paddingHorizontal: 10,
  },
  noData: {
    flex: 1,
    alignItems: "center",
  },
});
